import module_3df7983168ad43e793be8982b410ffa0 from '../includes/glsl-compat.vert'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\n\n'+
(module_3df7983168ad43e793be8982b410ffa0())+
'\n\nprecision '+
(obj.highp)+
' float;\n\nIN vec2 aTexCoord0;\n\nOUT vec2 vTexCoordFull;\n\nuniform float uReveal;\n\nvoid main(void){\n\n  vTexCoordFull = aTexCoord0;\n  \n  gl_Position.xy = 2.0 * aTexCoord0-vec2(1.0,1.0);\n  gl_Position.zw = vec2(0.1,0.5);\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
